import { Stack } from '@mui/material';

import { ErrorLoadingPage, Loading } from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';

import {
  CopartAlert,
  CoparticipationPreviewReportCard,
  CoparticipationPreviewReportSummary,
  EmptyCoparticipationPreview,
} from './components';
import { useCoparticipationPreview } from './hooks';

export function CoparticipationPreviewReportLayout() {
  const { coparticipationPreviewState, refreshCoparticipationPreview } =
    useCoparticipationPreview();
  const { hasFilters } = useFilterParams();

  const { isError, isLoading, data } = coparticipationPreviewState;

  if (isError) {
    return <ErrorLoadingPage onReloadClick={refreshCoparticipationPreview} />;
  }

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você.
          </>
        }
      />
    );
  }

  const totalCoparticipationPreviewLength =
    data?.coparticipationPreviewReports.length ?? 0;

  const isEmpty = totalCoparticipationPreviewLength === 0;

  if (isEmpty && !hasFilters) {
    return (
      <Stack paddingTop={3}>
        <EmptyCoparticipationPreview />
      </Stack>
    );
  }

  const { beneficiariesCount, proceduresCount, totalValue } =
    data?.summary ?? {};

  return (
    <Stack p={3} gap={3}>
      <CopartAlert />
      <CoparticipationPreviewReportSummary
        beneficiariesCount={beneficiariesCount}
        proceduresCount={proceduresCount}
        totalValue={totalValue}
      />
      <CoparticipationPreviewReportCard copartData={data} />
    </Stack>
  );
}
